import { Howl } from 'howler';

let sfxEnabled = true;

let sounds: {
  six: Howl | null;
  four: Howl | null;
  wicket: Howl | null;
} = {
  six: null,
  four: null,
  wicket: null,
};

let initialized = false;

function createHowl(srcs: string[]): Howl | null {
  try {
    return new Howl({
      src: srcs,
      preload: true,
      html5: false,
      pool: 1,
      volume: 0.7,
    });
  } catch {
    return null;
  }
}

function safePlay(sound: Howl | null): void {
  if (!sound) return;
  try {
    sound.stop();
    sound.play();
  } catch {
  }
}

export function initSfx(): void {
  if (initialized) return;
  initialized = true;

  try {
    sounds.six = createHowl(['/sfx/six_bat.mp3']);
    sounds.four = createHowl(['/sfx/four_bat.mp3']);
    sounds.wicket = createHowl(['/sfx/wkt_stumps.mp3']);

    const savedSetting = localStorage.getItem('sfxEnabled');
    if (savedSetting !== null) {
      sfxEnabled = savedSetting === 'true';
    }
  } catch {
  }
}

export function setSfxEnabled(enabled: boolean): void {
  sfxEnabled = enabled;
  try {
    localStorage.setItem('sfxEnabled', enabled.toString());
  } catch {
  }
}

export function isSfxEnabled(): boolean {
  return sfxEnabled;
}

export function playSixSfx(): void {
  if (!sfxEnabled) return;
  try {
    safePlay(sounds.six);
  } catch {
  }
}

export function playFourSfx(): void {
  if (!sfxEnabled) return;
  try {
    safePlay(sounds.four);
  } catch {
  }
}

export function playWicketSfx(): void {
  if (!sfxEnabled) return;
  try {
    safePlay(sounds.wicket);
  } catch {
  }
}
